import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { addApiKey, removeApiKey } from "../handlers/db";
import { toast } from "sonner";
import { v4 as uuidv4 } from "uuid";
import { CopyIcon } from "../components/Icons";
import { Button } from "../components/ui/button";

export default function APIKeys() {
  const { currentUser } = useAuth();
  const [isGenerating, setIsGenerating] = useState(false);
  // toasts handled via sonner

  const generateNewKey = async () => {
    if (!currentUser) return;

    setIsGenerating(true);
    try {
      const newKey = "pk_" + uuidv4().replace(/-/g, "");
      await addApiKey(currentUser, newKey);

      toast("New API key generated successfully");
    } catch (error) {
      console.error("Error generating API key:", error);
      toast("Failed to generate API key");
    } finally {
      setIsGenerating(false);
    }
  };

  const deleteKey = async (keyToDelete: string) => {
    if (!currentUser) return;

    try {
      await removeApiKey(currentUser, keyToDelete);
      toast("API key deleted successfully");
    } catch (error) {
      console.error("Error deleting API key:", error);
      toast("Failed to delete API key");
    }
  };

  return (
    <div className=" max-w-[850px]">
      {/* toasts handled globally */}

      <div className="flex justify-between items-center pt-10 pr-14 ">
        <h1 className="text-foreground pl-14  text-3xl font-bold">API Keys</h1>
        <Button onClick={generateNewKey} disabled={isGenerating}>
          {isGenerating ? "Generating..." : "Generate New Key"}
        </Button>
      </div>

      <div className="space-y-4 p-14">
        {currentUser?.apiKeys?.length === 0 && (
          <p className="text-foreground/70">
            No API keys found. Generate one to get started.
          </p>
        )}

        {currentUser?.apiKeys?.map((key) => (
          <div
            key={key}
            className="neo-surface border-2 rounded-md p-4 neo-shadow flex justify-between items-center"
          >
            <div>
              <Button
                size="sm"
                variant="secondary"
                className="mr-4 px-2"
                onClick={() => {
                  navigator.clipboard.writeText(key);
                  toast("API key copied to clipboard");
                }}
              >
                <CopyIcon />
              </Button>
              <code className="text-foreground/80 font-mono">{key}</code>
            </div>
            <Button variant="secondary" size="sm" onClick={() => deleteKey(key)}>
              Delete
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
